module.exports = __webpack_public_path__ + "img/wifi-2.6ec2e29b.svg";